export const ErrorMessages: any = {
  deploymentInprogressError: "503 Service unavailable. Deployment in progress",
  statusCodeNotFound: "Error status code not found",
  serverError: "Something went wrong. Please try again later.",
  terminalAPIError: "There was an error with the get terminals API.",
  dashboardSummaryAPIError:
    "Error occurred while fetching dashboard summary from API",
  validateOktaToken: "Unable to validate okta token. Please try again.",
  overageList: "Error occurred while fetching overage list from API",
  getExceptionList: "Error occurred while fetching exception list from API",
  exceptionAssign: "Error occurred while assigning osd to user",
  sendExcel: "Error occurred while sending excel to email",
  exceptionDetails: "Error occurred while fetching exception details from API",
  proImage: "Error occurred while fetching PRO images from API",
  manifestDetails: "Error occurred while fetching manifest details from API",
  manifestProDetails:
    "Error occurred while fetching manifest's PRO details from API",
  sendAPBMail: "Error occurred while sending APB mail, please try again",
  masterProNumber: "Error occurred while fetching master PRO numbers from API",
  masterOsdNumber: "Error occurred while fetching master OSD numbers from API",
  commodityTypeMaster:
    "Error occurred while fetching master commodity from API",
  exceptionCodesMaster:
    "Error occurred while fetching master exception codes from API",
  checkPro: "Error occurred while fetching check digit pro details from API",
  createOverageEntry: "Error creating overage entry. Please try again.",
  createMisdeliveryEntry: "Error creating misdelivery entry. Please try again.",
  misDeliveryList: "Error occurred while fetching misdelivery list from API",
  misDelivery: "Error occurred while fetching misdelivery details from API",
  createUpdateShortageInvestigation:
    "Error creating or updating shortage investigation entry. Please try again.",
  ohInvestigationError:
    "Error occured while investigation On hand Delivery exception. Please try again.",
  ohFollowupError:
    "Error occured while followup On hand Delivery exception. Please try again.",
  ohCreditHold: "Credit hold applied successfully to OS&D investigation notes.",
  updateExceptionLocationError:
    "Error occured while updating current location. Please try again.",
  saveOrSubmitDSInvestigation:
    "Error occurred while saving or submitting investigation notes. Please try again.",
  sendDispositionData:
    "Error occurred while fetching send disposition data. Please try again.",
  updateOverageEntry: "Error updating overage entry. Please try again.",
  updateASEntry: "Error updating all shortage entry. Please try again.",
  updateDSEntry: "Error updating delivered short entry. Please try again.",
  updatePREntry:
    "Error updating partial refusal exception entry. Please try again.",
  createShortageEntry: "Error creating shortage entry. Please try again.",
  createOnHandEntry: "Error creating On Hand entry. Please try again.",
  createMSDNotes: "Error creating MSD notes. Please try again.",
  getMSDNotes: "Error fetching MSD notes. Please try again.",
  updateOnHandEntry: "Error update On Hand entry. Please try again.",
  overageEntryDetailsAPIError:
    "Error occurred while fetching overage entry details from API",
  aSEntryDetailsAPIError:
    "Error occurred while fetching all shortage entry details from API",
  dSEntryDetailsAPIError:
    "Error occurred while fetching delivered short entry details from API",
  prEntryDetailsAPIError:
    "Error occurred while fetching refusal damage details from API",
  bnfEntryDetailsAPIError:
    "Error occurred while fetching bill no freight edit view details from API",
  bnfFollowUpAPIError: "Error occurred while bill no freight follow up",
  damageFollowUpAPIError: "Error occurred while damage follow up",

  PRFollowUpAPIError: "Error occurred while partial refusal follow up",
  saveOrSubmitAPIError:
    "Error occurred while saving or submitting investigation notes. Please try again.",
  getInvestigationAPIError:
    "Error occurred while fetching investigation from API",
  investigationImageUploadAPIError:
    "Failed to upload investigation image. Please try again",
  locationMaster: "Error occurred while fetching zip code master records",
  docTypeAPIError: "Error occurred while fetching doc types from API.",
  getShortagesAPIError:
    "Error occurred while fetching shortages. Please try again.",
  printAPIError: "Error occurred while printing. Please try again.",
  logglyLogAPIError:
    "Error occurred while log error in loggly. Please try again.",
  followUpSubmitted: "⁠OS&D follow up notes have been submitted successfully",
  investigationSubmitted: "⁠OS&D investigation notes have been submitted successfully",
  followUpCompleted: "⁠OS&D follow up notes have been completed successfully",
  followUpSave: "⁠OS&D follow up notes have been saved successfully",
  followUpUpdate: "⁠OS&D follow up notes have been updated successfully",
  freightLocatedSuccess:
    "OS&D investigation freight have been located successfully",
  investigationNoteSaved:
    "OS&D investigation notes have been saved successfully",
  investigationNoteCompleted:
    "OS&D investigation notes have been completed successfully & upload investigation image in progress",
  ohInvestigationNoteCompleted:
    "OS&D investigation notes have been completed successfully",
   investigationNoteSubmitted:
    "OS&D investigation notes have been Submitted successfully & upload investigation image in progress",
    userNotActive:
    "User is not active. Please log out of Okta and log in again to retry.",
  tokenRefreshFailed:
    "Token refresh failed after multiple retries. Please log out of Okta and log in again to retry.",
  dbUserInfoMissing:
    "Login failed because user information is missing in the database.",
  userEmailMissing:
    "Login failed because user's email information is missing in the database.",
  pickupDetailsAPIError:
    "Error occurred while fetching pickup details from API.",
  invalidPickupNumber: "Invalid pickup number",
  misdeliveryBolCreateError:
    "Error occurred while generating misdelivery BOL. Please try again.",
  unNaNumbersMaster: "Error occurred while fetching UN/NA# from API",
  clearingCodesMaster: "Error occurred while fetching clearing codes from API",
  investigationFailed: "OS&D Investigation is failed. Please try again."
};
